<i18n>
{
  "en": {
    "accentColor": "Accent color",
    "advancedSettings": "Show advanced settings",
    "auto": "Auto",
    "backgroundColor": "Section background color",
    "backgroundColors": "Backgrounds",
    "backgroundColorFreeText": "Background color for free text",
    "backgroundImage": "Section background image",
    "bannerOptions": "Banner",
    "bannerRecommendationArrowColor": "Arrow color of banner",
    "bannerRecommendationBackgroundColor": "Background color",
    "bannerRecommendationConfiguration": "Banner recommendation configuration",
    "bannerRecommendationTextColor": "Text color",
    "borderColor": "Border color",
    "borderConfiguration": "Border configurations",
    "borderOptions": "Borders",
    "borderStyle": "Border style",
    "borderWidth": "Border width",
    "brandingConfiguration": "Branding block configuration",
    "brandingOptions": "Branding",
    "cartCloseIconColor": "Shopping cart close icon color",
    "cartIconBottomPositionFactor": "Shopping cart icon bottom position factor",
    "cartIconColor": "Shopping cart icon color",
    "cartIconFontSizeFactor": "Shopping cart font size factor",
    "cartIconRightPositionFactor": "Shopping cart icon right position factor",
    "cartIconShadowColor": "Shopping cart icon shadow color",
    "cartIconSizeFactor": "Shopping cart icon size factor",
    "center": "Centered",
    "changeBackgroundImage": "Select other section background image",
    "commercialDescriptionIndentation": "Text indentation",
    "commercialDescriptionTextColor": "Text color",
    "commercialDescriptions": "Commercial descriptions",
    "confirmFontDeletion": "Are you sure you want to delete the font {0}?",
    "dashed": "Dashed",
    "defaultSettings": "Hide advanced settings",
    "delete": "Delete",
    "deletedFont": "Font deleted successfully",
    "deleteFontDescription": "This operation is irreversible and will affect to all menus where the font is assigned",
    "descriptionSeparationFactor": "Space size between product and its description",
    "dotted": "Dotted",
    "double": "Double",
    "emptyFieldError": "Mandatory field",
    "errorDeletingFont": "Error deleting font",
    "fileSizeError": "Image is too big. Maximum size is 2 MB.",
    "fontFamilies": "Font families",
    "fonts": "Fonts",
    "footerBackgroundColor": "Background color",
    "footerBrandingBackgroundColor": "Background color",
    "footerBrandingTextColor": "Text color",
    "footerBrandingTextSize": "Text size",
    "footerConfiguration": "Footer configuration",
    "footerOptions": "Footer",
    "footerTextColor": "Text color",
    "footerTextSize": "Text size",
    "getThemeError": "Error getting theme information. Please, try it later.",
    "groove": "Groove",
    "headerBackgroundColor": "Header background color",
    "inset": "Inset",
    "languageSelectorTextColor": "Text color of language selector",
    "left": "Left",
    "logoConfiguration": "Logo configuration",
    "logoOptions": "Logo",
    "logoPosition": "Logo position",
    "menuStructure": "Structure",
    "modalTitle": "Configure appearance",
    "outlineColor": "Text outline color",
    "outlineSeparationDescription": "Special product border spacing factor with respect to the text",
    "outlineWidth": "Text outline width",
    "outset": "Outset",
    "popUpBackgroundColor": "Background color",
    "popUpStyles": "Pop Up",
    "popUpTextColor": "Text color",
    "previousFile": "Previous File",
    "primaryColor": "Primary",
    "primaryExampleText": "Primary example text",
    "primaryFont": "Title font",
    "primaryFontSizeFactor": "Primary font size factor",
    "productSeparationFactor": "Space size between products",
    "productSeparatorBorderStyle": "Product separator border style",
    "productSeparatorBorderWidth": "Product separator border width",
    "productSeparatorBorderColor": "Product separator border color",
    "productSeparatorConfiguration": "Product Separator Border Configuration",
    "ridge": "Ridge",
    "right": "Right",
    "secondaryColor": "Secondary",
    "secondaryExampleText": "Secondary example text",
    "secondaryFont": "Text font",
    "secondaryFontSizeFactor": "Secondary font size factor",
    "sectionTitleBackgroundColor": "Background color",
    "sectionTitleConfiguration": "Section title configuration",
    "sectionTitlePosition": "Position",
    "sectionTitleOptions": "Section titles",
    "sectionTitleTextColor": "Text color",
    "showLogo": "Show logo in blackboard header",
    "showUseShoppingCart": "Shopping Cart",
    "sizeFactor": "Menu structure",
    "solid": "Solid",
    "specialColor": "Special product",
    "subsectionBorderStyle": "Subsection title border style",
    "subsectionBorderWidth": "Subsection title border width",
    "subsectionBorderColor": "Subsection title border color",
    "textColors": "Text colors",
    "shopBtnColor": "Color of cart buttons and product popups",
    "shopBtnTextColor": "Text color of cart buttons and product popup"
  },
  "es": {
    "accentColor": "Color de acento",
    "advancedSettings": "Mostrar opciones avanzadas",
    "auto": "Auto",
    "backgroundColorFreeText": "Color de fondo para los textos libres",
    "backgroundColor": "Color de fondo para secciones",
    "backgroundColors": "Fondos",
    "backgroundImage": "Imagen de fondo para secciones",
    "bannerOptions": "Banner",
    "bannerRecommendationArrowColor":  "Color de la flecha del banner",
    "bannerRecommendationBackgroundColor": "Color de fondo",
    "bannerRecommendationConfiguration": "Configuración de la recomendación de tipo banner",
    "bannerRecommendationTextColor": "Color",
    "borderOptions": "Bordes",
    "borderColor": "Color del borde",
    "borderConfiguration": "Configuración de bordes",
    "borderStyle": "Estilo del borde",
    "borderWidth": "Anchura del borde",
    "brandingConfiguration": "Configuración del bloque de branding",
    "brandingOptions": "Branding",
    "cartCloseIconColor": "Color para el icono de cierre del carrito de la compra",
    "cartIconBottomPositionFactor": "Factor de tamaño para la posición del icono respecto al margen inferior",
    "cartIconColor": "Color para el icono del carrito de la compra",
    "cartIconFontSizeFactor": "Factor de tamaño para la fuente en el carrito de la compra",
    "cartIconRightPositionFactor": "Factor de tamaño para la posición del icono respecto al margen derecho",
    "cartIconShadowColor": "Color para la sombra del icono del carrito de la compra",
    "cartIconSizeFactor": "Factor de tamaño para el icono del carrito de la compra",
    "center": "Centrado",
    "changeBackgroundImage": "Selecciona otra imagen de fondo para secciones",
    "commercialDescriptions": "Descripciones comerciales",
    "commercialDescriptionTextColor": "Color de las descripciones comerciales",
    "commercialDescriptionIndentation": "Sangría de las descripciones comerciales",
    "confirmFontDeletion": "¿Está seguro de que quiere eliminar la fuente {0}?",
    "dashed": "Línea discontinua",
    "defaultSettings": "Ocultar opciones avanzadas",
    "delete": "Eliminar",
    "deleteFontDescription": "Esta operación es irreversible y afectará a todas las cartas con la fuente asignada",
    "deletedFont": "Fuente borrada exitosamente",
    "dotted": "Línea de puntos",
    "double": "Doble bordeado",
    "descriptionSeparationFactor": "Factor de tamaño del espacio entre el producto y la descripción",
    "emptyFieldError": "Campo obligatorio",
    "errorDeletingFont": "Error eliminando fuente",
    "fileSizeError": "La imagen es demasiado grande. El tamaño máximo es 2 MB.",
    "fontFamilies": "Tipos de letra",
    "fonts": "Fuentes",
    "footerBackgroundColor": "Color de fondo",
    "footerBrandingBackgroundColor": "Color de fondo",
    "footerBrandingTextColor": "Color del texto",
    "footerBrandingTextSize": "Tamaño del texto",
    "footerConfiguration": "Configuración del footer",
    "footerOptions": "Pie del menu",
    "footerTextColor": "Color del texto",
    "footerTextSize": "Tamaño del texto",
    "getThemeError": "Error obteniendo información de personalización. Por favor, inténtelo de nuevo más tarde",
    "groove": "Borde de ranura",
    "inset": "Borde recuadrado",
    "headerBackgroundColor": "Color de fondo para la cabecera",
    "languageSelectorTextColor":  "Color de texto del selector de idioma",
    "left": "Izquierda",
    "logoConfiguration": "Configuración del logo",
    "logoOptions": "Logo",
    "logoPosition": "Posición",
    "menuStructure": "Estructura",
    "modalTitle": "Configurar apariencia",
    "outlineColor": "Color del perfilado del texto",
    "outlineSeparationDescription": "Factor de separacion del borde del producto especial con respecto al texto",
    "outlineWidth": "Anchura del perfilado del texto",
    "outset": "Recuadrado invertido",
    "popUpBackgroundColor": "Color de fondo",
    "popUpStyles": "Recomendación inicial",
    "popUpTextColor": "Color del texto",
    "previousFile": "Archivo anterior",
    "primaryColor": "Primario",
    "primaryExampleText": "Ejemplo de texto primario",
    "primaryFont": "Fuente del título",
    "primaryFontSizeFactor": "Factor de tamaño de la fuente primaria",
    "productSeparationFactor": "Factor de tamaño del espacio entre productos",
    "productSeparatorBorderColor": "Color del borde del separador del producto",
    "productSeparatorBorderStyle": "Estilo del borde del separador del producto",
    "productSeparatorBorderWidth": "Anchura del borde del separador del producto",
    "productSeparatorConfiguration": "Configuracion del separador del producto",
    "ridge": "Borde en cresta",
    "right": "Derecha",
    "secondaryColor": "Secundario",
    "secondaryExampleText": "Ejemplo de texto secundario",
    "secondaryFont": "Fuente del texto",
    "secondaryFontSizeFactor": "Factor de tamaño de la fuente secundaria",
    "sectionTitleBackgroundColor": "Color de fondo",
    "sectionTitleConfiguration": "Configuración del título de sección",
    "sectionTitleOptions": "Títulos de sección",
    "sectionTitlePosition": "Posición",
    "sectionTitleTextColor": "Color del texto",
    "showLogo": "Mostrar el logo en el encabezado de la pizarra",
    "showUseShoppingCart": "Carrito",
    "sizeFactor": "Estructura de la carta",
    "solid": "Sólido",
    "specialColor": "Producto especial",
    "subsectionBorderStyle": "Estilo del borde del título de la subsección",
    "subsectionBorderWidth": "Anchura del borde del título de la subsección",
    "subsectionBorderColor": "Color del borde del título de la subsección",
    "textColors": "Colores de texto",
    "shopBtnColor": "Color de los botones del carrito y popup de los productos",
    "shopBtnTextColor": "Color del texto de los botones del carrito y popup de los productos"
  }
}
</i18n>

<template>
  <v-dialog @click:outside="onCancel" v-model="visible" max-width="600px" persistent>
    <div v-if=visible class="px-7 py-5">
      <v-card-title class="pa-0">
        {{ this.$t('modalTitle') }}
      </v-card-title>
      <div style="background-color: #ffffff">
        <v-form v-model="valid" ref="form">
          <v-tabs v-model="tab" class="my-tabs" background-color="transparent" show-arrows>
            <v-tab>{{ $t('fonts') }}</v-tab>
            <v-tab>{{ $t('textColors') }}</v-tab>
            <v-tab v-if="showCommercialDescriptionTextColor||showCommercialDescriptionIndentation">{{ $t('commercialDescriptions') }}</v-tab>
            <v-tab v-if="showBackgroundImageFile||showSectionBackgroundColor||showBackgroundFreeText||showHeaderBackgroundColor">{{ $t('backgroundColors') }}</v-tab>
            <v-tab v-if="showPopUpBackgroundColor||showPopUpTextColor">{{ $t('popUpStyles') }}</v-tab>
            <v-tab v-if="showUseShoppingCart">{{ $t('shoppingCart') }}</v-tab>
            <v-tab v-if="showProductSeparationFactor||showDescriptionSeparationFactor||showSpecialSpaceBorder||showProductBorderSeparator">{{ $t('menuStructure') }}</v-tab>
            <v-tab v-if="showBorderConfiguration||showBorderSubsectionBorder">{{ $t('borderOptions') }}</v-tab>
            <v-tab v-if="showLogoOption">{{ $t('logoOptions') }}</v-tab>
            <v-tab v-if="showFooterOption">{{ $t('footerOptions') }}</v-tab>
            <v-tab v-if="showBrandingOption">{{ $t('brandingOptions') }}</v-tab>
            <v-tab v-if="showSectionTitleOption">{{ $t('sectionTitleOptions') }}</v-tab>
            <v-tab v-if="showBannerRecommendationOption">{{ $t('bannerOptions') }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" data-testid="tab-input">
            <!-- Font options -->
            <v-tab-item class="mt-5">
              <v-select v-model="primaryFont" :items="this.fontFamiliesToArray"
                        :menu-props="{ maxHeight: '400' }" prepend-icon="mdi-plus"
                        :append-icon="primaryFontDeleteIcon" @click:append="onClearFont('primary')"
                        @click:prepend="onOpenFontCreateModal('primary')"
                        :rules="[(v) => !!v || $t('emptyFieldError')]"
                        :label="this.$t('primaryFont')" required>
                <template slot="selection" slot-scope="data">
                  <span :style="{fontFamily: data.item.text}">{{ data.item.text }}</span>
                </template>
                <template slot="item" slot-scope="data">
                  <span :style="{fontFamily: data.item.text}">{{ data.item.text }}</span>
                </template>
              </v-select>
              <v-select v-if="showSecondaryFont" v-model="secondaryFont"
                        :items="this.fontFamiliesToArray" :menu-props="{ maxHeight: '400' }"
                        :label="this.$t('secondaryFont')"
                        :append-icon="secondaryFontDeleteIcon"
                        @click:append="onClearFont('secondary')"
                        prepend-icon="mdi-plus" @click:prepend="onOpenFontCreateModal('secondary')"
                        :rules="[(v) => !!v || $t('emptyFieldError')]"
                        required>
                <template slot="selection" slot-scope="data">
                  <span :style="{fontFamily: data.item.text}">{{ data.item.text }}</span>
                </template>
                <template slot="item" slot-scope="data">
                  <span :style="{fontFamily: data.item.text}">{{ data.item.text }}</span>
                </template>
              </v-select>
              <v-divider class="mt-2"/>
              <!-- Font Size factor options -->
              <v-subheader class="pa-0">
                {{ this.$t('primaryFontSizeFactor') }}
              </v-subheader>
              <v-slider v-model="primaryFontSizeFactor" color="#032c58" min="-5" max="5"
                        thumb-label/>
              <v-footer :style="primaryStyle"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('primaryExampleText') }}
              </v-footer>
              <v-subheader v-if="showSecondaryFontSizeFactor" class="pa-0">
                {{ this.$t('secondaryFontSizeFactor') }}
              </v-subheader>
              <v-slider v-if="showSecondaryFontSizeFactor" v-model="secondaryFontSizeFactor"
                        color="#032c58"
                        min="-5" max="5" thumb-label
              />
              <v-footer v-if="showSecondaryFontSizeFactor" :style="secondaryStyle"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('secondaryExampleText') }}
              </v-footer>
            </v-tab-item>
            <!-- Text colors options -->
            <v-tab-item class="mt-5">
              <!-- Primary Text Color -->
              <label class="v-label v-label--active theme--light position-elements">{{
                  $t('primaryColor')
                }}</label>
              <v-row justify="center">
                <v-color-picker v-model="primaryColor" hide-mode-switch
                                mode="hexa"/>
              </v-row>
              <!-- Secondary Text Color -->
              <label v-if="showSecondaryColor"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('secondaryColor') }}
              </label>
              <v-row justify="center" v-if="showSecondaryColor">
                <v-color-picker v-model="secondaryColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>
              <!-- Accent Text Color -->
              <label v-if="showAccentColor"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('accentColor') }}
              </label>
              <v-row justify="center" v-if="showAccentColor">
                <v-color-picker v-model="accentColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>
              <!-- Text outline parameters -->
              <label v-if="showTextOutlineOptions"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('outlineColor') }}
              </label>
              <v-row v-if="showTextOutlineOptions" justify="center">
                <v-color-picker v-model="textOutlineColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>
              <label v-if="showTextOutlineOptions"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('outlineWidth') }}
              </label>
              <v-slider v-if="showTextOutlineOptions"
                        v-model="textOutlineWidth" color="#032c58" min="1" max="10"
                        thumb-label/>
              <!-- Special product color picker -->
              <label v-if="showSpecialProductColor"
                     class="v-label v-label--active theme--light position-elements">{{ $t('specialColor') }}</label>
              <v-row v-if="showSpecialProductColor" justify="center">
                <v-color-picker v-model="specialColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>
              <!-- Language selector text color picker -->
              <label v-if="showLanguageSelectorTextColor"
                     class="v-label v-label--active theme--light position-elements">{{ $t('languageSelectorTextColor') }}</label>
              <v-row v-if="showLanguageSelectorTextColor" justify="center">
                <v-color-picker v-model="languageSelectTextColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>
            </v-tab-item>
            <!-- Commercial description options -->
            <v-tab-item class="mt-5"
              v-if="showCommercialDescriptionTextColor||showCommercialDescriptionIndentation">
              <!-- Commercial Description Text Color -->
              <label v-if="showCommercialDescriptionTextColor"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('commercialDescriptionTextColor') }}
              </label>
              <v-row v-if="showCommercialDescriptionTextColor" justify="center">
                <v-color-picker v-model="commercialDescriptionTextColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>
              <!-- Commercial Description Indentation -->
              <label v-if="showCommercialDescriptionIndentation"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('commercialDescriptionIndentation') }}
              </label>
              <v-slider v-if="showCommercialDescriptionIndentation"
                        v-model="commercialDescriptionIndentation" color="#032c58" min="0" max="10"
                        thumb-label/>
            </v-tab-item>
            <!-- Background options -->
            <v-tab-item class="mt-5"
                        v-if="showBackgroundImageFile||showSectionBackgroundColor||showBackgroundFreeText||showHeaderBackgroundColor">
              <!-- Background Image -->
              <v-row v-if="showBackgroundImageFile">
                <v-subheader>{{ this.$t('backgroundImage') }}</v-subheader>
                <v-avatar v-if="backgroundImage" size="50" class="border-avatar">
                  <img :src="backgroundImage" alt="theme image">
                </v-avatar>
              </v-row>
              <v-file-input v-if="showBackgroundImageFile" v-model="backgroundImageFile"
                            :rules="imageRules" show-size
                            accept="image/png, image/jpeg, image/bmp" prepend-icon="mdi-camera"
                            :label="$t('changeBackgroundImage')"/>
              <!-- Section Background Color -->
              <label v-if="!backgroundImage && showSectionBackgroundColor"
                     class="v-label v-label--active theme--light position-elements">{{
                  $t('backgroundColor')
                }}</label>
              <v-row v-if="!backgroundImage && showSectionBackgroundColor" justify="center">
                <v-color-picker v-model="backgroundColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>

              <!-- Free text background Color -->
              <label v-if="showBackgroundFreeText"
                     class="v-label v-label--active theme--light position-elements">{{
                  $t('backgroundColorFreeText')
                }}</label>
              <v-row v-if="showBackgroundFreeText" justify="center">
                <v-color-picker v-model="backgroundColorFreeText" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>

              <!-- Header Background Color -->
              <label v-if="showHeaderBackgroundColor"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('headerBackgroundColor') }}
              </label>
              <v-row v-if="showHeaderBackgroundColor" justify="center">
                <v-color-picker v-model="headerBackgroundColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>
            </v-tab-item>
            <!-- Pop Up options -->
            <v-tab-item class="mt-5" v-if="showPopUpBackgroundColor||showPopUpTextColor">
              <!-- Pop Up Background Color -->
              <label v-if="showPopUpBackgroundColor"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('popUpBackgroundColor') }}
              </label>
              <v-row v-if="showPopUpBackgroundColor" justify="center">
                <v-color-picker v-model="popUpBackgroundColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>

              <!-- Pop Up Text Color -->
              <label v-if="showPopUpTextColor"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('popUpTextColor') }}
              </label>
              <v-row v-if="showPopUpTextColor" justify="center">
                <v-color-picker v-model="popUpTextColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>
            </v-tab-item>
            <!-- Shopping cart options -->
            <v-tab-item v-if="showUseShoppingCart" class="mt-5">
              <label class="v-label v-label--active theme--light position-elements">
                {{ $t('shopBtnColor') }}
              </label>
              <v-row justify="center">
                <v-color-picker v-model="shopBtnColor" hide-mode-switch mode="hexa"/>
              </v-row>
              <label class="v-label v-label--active theme--light position-elements">
                {{ $t('shopBtnTextColor') }}</label>
              <v-row justify="center">
                <v-color-picker v-model="shopBtnTextColor" hide-mode-switch
                                mode="hexa"/>
              </v-row>
            </v-tab-item>
            <!-- Menu Structure options -->
            <v-tab-item class="mt-5"
                        v-if="showProductSeparationFactor||showDescriptionSeparationFactor||showSpecialSpaceBorder||showProductBorderSeparator">
              <v-subheader v-if="showProductSeparationFactor" class="pa-0">
                {{ this.$t('productSeparationFactor') }}
              </v-subheader>
              <v-slider v-if="showProductSeparationFactor" v-model="productSeparationFactor"
                        color="#032c58"
                        min="-10" max="10" thumb-label/>
              <v-subheader v-if="showDescriptionSeparationFactor" class="pa-0">
                {{ this.$t('descriptionSeparationFactor') }}
              </v-subheader>
              <v-slider v-if="showDescriptionSeparationFactor" v-model="descriptionSeparationFactor"
                        color="#032c58" min="-5" max="5" thumb-label/>
              <v-subheader v-if="showSpecialSpaceBorder" class="pa-0">
                {{ this.$t('outlineSeparationDescription') }}
              </v-subheader>
              <v-slider v-if="showSpecialSpaceBorder" v-model="specialSpaceBorder"
                        color="#032c58" min="0" max="10" thumb-label/>
              <!--   Product separator line  -->
              <v-divider v-if="showProductBorderSeparator" class="mt-2 mb-2"/>
              <div v-if="showProductBorderSeparator" class="mb-2">
                {{ $t('productSeparatorConfiguration') }}
              </div>
              <v-select v-if="showProductBorderSeparator" v-model="productSeparatorBorderStyle"
                        :items="this.borderStylesToArray"
                        :menu-props="{ maxHeight: '400' }"
                        :rules="[(v) => !!v || $t('emptyFieldError')]"
                        :label="this.$t('productSeparatorBorderStyle')" required>
                <template slot="selection" slot-scope="data">
                  <span>
                    {{ data.item.text }}</span>
                </template>
                <template slot="item" slot-scope="data">
                  <span class="style-format-padding" :style="{borderStyle: data.item.value}">
                    {{ data.item.text }}</span>
                </template>
              </v-select>
              <v-subheader v-if="showProductBorderSeparator" class="pa-0">
                {{ this.$t('productSeparatorBorderWidth') }}
              </v-subheader>
              <v-slider v-if="showProductBorderSeparator" v-model="productSeparatorBorderWidth"
                        color="#032c58" min="1" max="10" thumb-label/>
              <label v-if="showProductBorderSeparator"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('productSeparatorBorderColor') }}</label>
              <v-row v-if="showProductBorderSeparator" justify="center">
                <v-color-picker v-model="productSeparatorBorderColor" hide-mode-switch mode="hexa"/>
              </v-row>
            </v-tab-item>
            <!-- Border options -->
            <v-tab-item class="mt-5" v-if="showBorderConfiguration||showBorderSubsectionBorder">
              <v-select v-if="showBorderConfiguration" v-model="borderStyle"
                        :items="this.borderStylesToArray"
                        :menu-props="{ maxHeight: '400' }"
                        :rules="[(v) => !!v || $t('emptyFieldError')]"
                        :label="this.$t('borderStyle')" required>
                <template slot="selection" slot-scope="data">
                  <span>
                    {{ data.item.text }}</span>
                </template>
                <template slot="item" slot-scope="data">
                  <span class="style-format-padding" :style="{borderStyle: data.item.value}">
                    {{ data.item.text }}</span>
                </template>
              </v-select>
              <v-subheader v-if="showBorderSubsectionBorder" class="pa-0">
                {{ this.$t('borderWidth') }}
              </v-subheader>
              <v-slider v-if="showBorderSubsectionBorder" v-model="borderWidth"
                        color="#032c58" min="1" max="25" thumb-label/>
              <label v-if="showBorderSubsectionBorder"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('borderColor') }}</label>
              <v-row v-if="showBorderSubsectionBorder" justify="center">
                <v-color-picker v-model="borderColor" hide-mode-switch mode="hexa"/>
              </v-row>
              <v-select v-if="showBorderSubsectionBorder" v-model="subsectionBorderStyle"
                        :items="this.borderStylesToArray"
                        :menu-props="{ maxHeight: '400' }"
                        :rules="[(v) => !!v || $t('emptyFieldError')]"
                        :label="this.$t('subsectionBorderStyle')" required>
                <template slot="selection" slot-scope="data">
                  <span>
                    {{ data.item.text }}</span>
                </template>
                <template slot="item" slot-scope="data">
                  <span class="style-format-padding" :style="{borderStyle: data.item.value}">
                    {{ data.item.text }}</span>
                </template>
              </v-select>
              <v-subheader v-if="showBorderSubsectionBorder" class="pa-0">
                {{ this.$t('subsectionBorderWidth') }}
              </v-subheader>
              <v-slider v-if="showBorderSubsectionBorder" v-model="subsectionBorderWidth"
                        color="#032c58" min="5" max="25" thumb-label/>
              <label v-if="showBorderSubsectionBorder"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('subsectionBorderColor') }}</label>
              <v-row v-if="showBorderSubsectionBorder" justify="center">
                <v-color-picker v-model="subsectionBorderColor" hide-mode-switch mode="hexa"/>
              </v-row>
            </v-tab-item>
            <!-- Logo options -->
            <v-tab-item v-if="showLogoOption" class="mt-5">
              <v-switch v-if="showLogoOption"
                        v-model="hasLogo"
                        :label="$t('showLogo')"/>
              <v-select v-if="showLogoOption"
                        v-model="logoPosition"
                        :items="this.positionsToArray"
                        :menu-props="{ maxHeight: '400' }"
                        :rules="[(v) => !!v || $t('emptyFieldError')]"
                        :label="this.$t('logoPosition')" required>
                <template slot="selection" slot-scope="data">
                  <span>
                    {{ data.item.text }}</span>
                </template>
                <template slot="item" slot-scope="data">
                  <span class="style-format-padding" :style="{borderStyle: data.item.value}">
                    {{ data.item.text }}</span>
                </template>
              </v-select>
            </v-tab-item>
            <!-- Footer options -->
            <v-tab-item class="mt-5" v-if="showFooterOption">
              <label v-if="showFooterOption"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('footerBackgroundColor') }}
              </label>
              <v-row v-if="showFooterOption" justify="center">
                <v-color-picker v-model="footerBackgroundColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>

              <label v-if="showFooterOption"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('footerTextColor') }}
              </label>
              <v-row v-if="showFooterOption" justify="center">
                <v-color-picker v-model="footerTextColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>

              <v-subheader v-if="showFooterOption" class="pa-0" :style="secondaryStyle">
                {{ this.$t('footerTextSize') }}
              </v-subheader>
              <v-slider v-if="showFooterOption" v-model="footerTextSize"
                        color="#032c58"
                        min="-5" max="5" thumb-label/>
            </v-tab-item>
            <!-- Branding options -->
            <v-tab-item v-if="showBrandingOption" class="mt-5">
              <label v-if="showBrandingOption"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('footerBrandingBackgroundColor') }}
              </label>
              <v-row v-if="showBrandingOption" justify="center">
                <v-color-picker v-model="footerBrandingBackgroundColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>

              <label v-if="showBrandingOption"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('footerBrandingTextColor') }}
              </label>
              <v-row v-if="showBrandingOption" justify="center">
                <v-color-picker v-model="footerBrandingTextColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>

              <v-subheader v-if="showBrandingOption" class="pa-0" :style="secondaryStyle">
                {{ this.$t('footerBrandingTextSize') }}
              </v-subheader>
              <v-slider v-if="showBrandingOption" v-model="footerBrandingTextSize"
                        color="#032c58"
                        min="-5" max="5" thumb-label/>
            </v-tab-item>
            <!-- Section title options -->
            <v-tab-item class="mt-5" v-if="showSectionTitleOption">
              <label v-if="showSectionTitleOption"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('sectionTitleBackgroundColor') }}
              </label>
              <v-row v-if="showSectionTitleOption" justify="center">
                <v-color-picker v-model="sectionTitleBackgroundColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>

              <label v-if="showSectionTitleOption"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('sectionTitleTextColor') }}
              </label>
              <v-row v-if="showSectionTitleOption" justify="center">
                <v-color-picker v-model="sectionTitleTextColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>

              <v-select v-if="showSectionTitleOption"
                        v-model="sectionTitlePosition"
                        :items="this.positionsToArray"
                        :menu-props="{ maxHeight: '400' }"
                        :rules="[(v) => !!v || $t('emptyFieldError')]"
                        :label="this.$t('sectionTitlePosition')" required>
                <template slot="selection" slot-scope="data">
                  <span>
                    {{ data.item.text }}</span>
                </template>
                <template slot="item" slot-scope="data">
                  <span class="style-format-padding" :style="{borderStyle: data.item.value}">
                    {{ data.item.text }}</span>
                </template>
              </v-select>
            </v-tab-item>
            <!-- Banner options -->
            <v-tab-item v-if="showBannerRecommendationOption" class="mt-5">
              <label v-if="showBannerRecommendationOption"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('bannerRecommendationBackgroundColor') }}
              </label>
              <v-row v-if="showBannerRecommendationOption" justify="center">
                <v-color-picker v-model="bannerRecommendationBackgroundColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>

              <label v-if="showBannerRecommendationOption"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('bannerRecommendationTextColor') }}
              </label>
              <v-row v-if="showBannerRecommendationOption" justify="center">
                <v-color-picker v-model="bannerRecommendationTextColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>
              <label v-if="showBannerRecommendationOption"
                     class="v-label v-label--active theme--light position-elements">
                {{ $t('bannerRecommendationArrowColor') }}
              </label>
              <v-row v-if="showBannerRecommendationOption" justify="center">
                <v-color-picker v-model="bannerArrowColor" hide-mode-switch
                                mode="hexa"></v-color-picker>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
        <dynameat-modal-buttons @cancel="onCancel" @confirm="onConfirm" :confirmDisabled="!valid"
                                :confirmText="$t('confirm')" class="mt-4"/>
      </div>
    </div>
    <font-create-modal :visible="fontModalVisible" @confirm="onCreateFont" @cancel="onCancelFont"/>
    <dynameat-confirmation-modal :visible="fontDeletionModalVisible"
                                 :title="fontDeletionText"
                                 :description="$t('deleteFontDescription')"
                                 :confirm-text="$t('delete')"
                                 @confirm="onDeleteFont"
                                 @cancel="onCancelFontDeletion"/>
  </v-dialog>
</template>

<script>
import { maxSize } from '@core/helpers/formValidators';
import { createErrorNotification, createSuccessNotification } from '@ulibs/unnotificationsqueue';
import Component from 'vue-class-component';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import { Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import DynameatModalButtons from '@dynameat/components/DynameatModalButtons';
import DynameatConfirmationModal from '@dynameat/components/DynameatConfirmationModal';
import { loadFont } from '@core/helpers';
import FontCreateModal from './FontCreateModal.vue';
import { Theme } from '../models';

@Component
@Components({ DynameatModalButtons, DynameatConfirmationModal, FontCreateModal })
@MapGetters(['templateList', 'menuFontList', 'defaultMenuFont'])
@MapActions(['themeRequest', 'addNotification', 'deleteMenuFontRequest'])
export default class MenuAppearanceModal extends Vue {
  @Prop({ String, default: 'themeGuid' }) themeGuid;

  @Prop({ String, default: 'templateGuid ' }) templateGuid;

  @Prop({ Boolean, default: false }) visible;

  theme = Theme.toInstance();

  valid = false;

  primaryColor = '';

  secondaryColor = '';

  primaryFont = '';

  secondaryFont = '';

  accentColor = '';

  textOutlineColor = '';

  textOutlineWidth = 0;

  primaryFontSizeFactor = '';

  secondaryFontSizeFactor = '';

  productSeparationFactor = '';

  descriptionSeparationFactor = '';

  backgroundColor = '';

  backgroundColorFreeText = ''

  backgroundImage = '';

  headerBackgroundColor = '';

  specialColor = ''

  languageSelectTextColor = '';

  specialSpaceBorder = 0;

  backgroundImageFile = null;

  isAdvanced = false;

  fontModalVisible = false;

  fontDeletionModalVisible = false;

  fontBeingEdited = 'primary';

  fontBeingDeleted = 'primary';

  shopBtnColor = '';

  shopBtnTextColor = '';

  borderColor = '';

  borderStyle = '';

  borderWidth = 0;

  subsectionBorderColor = '';

  subsectionBorderStyle = '';

  subsectionBorderWidth = 0;

  productSeparatorBorderColor = '';

  productSeparatorBorderStyle = '';

  productSeparatorBorderWidth = 0;

  hasLogo = false;

  logoPosition = 'left'

  popUpBackgroundColor = '';

  popUpTextColor = '';

  commercialDescriptionTextColor = '';

  commercialDescriptionIndentation = 0;

  footerBackgroundColor = '';

  footerTextColor = '';

  footerTextSize = 0;

  footerBrandingBackgroundColor = '';

  footerBrandingTextColor = '';

  footerBrandingTextSize = 0;

  sectionTitleBackgroundColor = '';

  sectionTitleTextColor = '';

  sectionTitlePosition = 'left';

  bannerRecommendationBackgroundColor = '';

  bannerRecommendationTextColor = '';

  bannerArrowColor = ''

  tab = 0;

  get imageRules() {
    return [maxSize(this.$t('fileSizeError'), 2000000)];
  }

  get fontFamiliesToArray() {
    return this.menuFontList.map((font) => ({ value: font.guid, text: font.fontFamily }));
  }

  get defaultFont() {
    return this.menuFontList.length > 0 && this.menuFontList.filter(({ isSystemFont }) => isSystemFont)[0];
  }

  get currentTemplate() {
    return this.templateList.find((el) => el.guid === this.templateGuid);
  }

  get showSecondaryFont() {
    return !this.currentTemplate.isOperationDisallowed('THEME', 'SECONDARY_FONT');
  }

  get showSecondaryFontSizeFactor() {
    return !this.currentTemplate.isOperationDisallowed('THEME', 'SECONDARY_FONT_SIZE_FACTOR');
  }

  get showSecondaryColor() {
    return !this.currentTemplate.isOperationDisallowed('THEME', 'SECONDARY_COLOR');
  }

  get showProductSeparationFactor() {
    return !this.currentTemplate.isOperationDisallowed('THEME', 'PRODUCT_SEPARATION_FACTOR');
  }

  get showDescriptionSeparationFactor() {
    return !this.currentTemplate.isOperationDisallowed('THEME', 'DESCRIPTION_SEPARATION_FACTOR');
  }

  get showAccentColor() {
    return !this.currentTemplate.isOperationDisallowed('THEME', 'ACCENT_COLOR');
  }

  get showSpecialSpaceBorder() {
    return !this.currentTemplate.isOperationDisallowed('THEME', 'SPECIAL_SPACE_BORDER');
  }

  get showBackgroundImageFile() {
    return !this.currentTemplate.isOperationDisallowed('THEME', 'BACKGROUND_IMAGE_FILE');
  }

  get showBorderConfiguration() {
    return !this.currentTemplate.isOperationDisallowed('THEME', 'BORDER_CONFIGURATION');
  }

  get showBorderSubsectionBorder() {
    return !this.currentTemplate.isOperationDisallowed('THEME', 'BORDER_CONFIGURATION') || !this.currentTemplate.isOperationDisallowed('THEME', 'SUBSECTION_BORDER');
  }

  get showLogoOption() {
    return !this.currentTemplate.isOperationDisallowed('THEME', 'USE_LOGO_OPTION');
  }

  get showUseShoppingCart() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'USE_SHOPPING_CART');
  }

  get showHeaderBackgroundColor() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'HEADER_BACKGROUND_COLOR');
  }

  get showBackgroundFreeText() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'BACKGROUND_FREE_TEXT');
  }

  get showSectionBackgroundColor() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'SECTION_BACKGROUND_COLOR');
  }

  get showSpecialProductColor() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'COLOR_SPECIAL_PRODUCT');
  }

  get showLanguageSelectorTextColor() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'LANGUAGE_SELECT_TEXT_COLOR');
  }

  get showPopUpBackgroundColor() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'POP_UP_BACKGROUND_COLOR');
  }

  get showPopUpTextColor() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'POP_UP_TEXT_COLOR');
  }

  get showCommercialDescriptionTextColor() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'COMMERCIAL_DESCRIPTION_TEXT_COLOR');
  }

  get showCommercialDescriptionIndentation() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'DESCRIPTION_TEXT_INDENTATION');
  }

  get showTextOutlineOptions() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'TEXT_OUTLINE');
  }

  get showFooterOption() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'SHOW_FOOTER_OPTION');
  }

  get showBrandingOption() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'SHOW_BRANDING_OPTION');
  }

  get showSectionTitleOption() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'SHOW_SECTION_TITLE_OPTION');
  }

  get showBannerRecommendationOption() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'SHOW_BANNER_RECOMMENDATION_OPTION');
  }

  get showProductBorderSeparator() {
    return !this.currentTemplate?.isOperationDisallowed('THEME', 'SHOW_PRODUCT_SEPARATOR_OPTION');
  }

  get primaryFontDeleteIcon() {
    const font = this.menuFontList.find((el) => el.guid === this.primaryFont);
    return !font || font.isSystemFont ? undefined : 'mdi-trash-can';
  }

  get secondaryFontDeleteIcon() {
    const font = this.menuFontList.find((el) => el.guid === this.secondaryFont);
    return !font || font.isSystemFont ? undefined : 'mdi-trash-can';
  }

  get fontDeletionText() {
    const fontGuid = this.fontBeingDeleted === 'primary' ? this.primaryFont : this.secondaryFont;
    const font = this.menuFontList.find((el) => el.guid === fontGuid);
    if (font) return this.$t('confirmFontDeletion', [font.fontFamily]);
    return this.$t('confirmFontDeletion', ['']);
  }

  get borderStylesToArray() {
    return [{ value: 'auto', text: this.$t('auto') }, { value: 'dashed', text: this.$t('dashed') },
      { value: 'dotted', text: this.$t('dotted') }, { value: 'double', text: this.$t('double') },
      { value: 'groove', text: this.$t('groove') }, { value: 'inset', text: this.$t('inset') },
      { value: 'outset', text: this.$t('outset') }, { value: 'ridge', text: this.$t('ridge') },
      { value: 'solid', text: this.$t('solid') }];
  }

  get positionsToArray() {
    return [
      { value: 'left', text: this.$t('left') },
      { value: 'center', text: this.$t('center') },
      { value: 'right', text: this.$t('right') }
    ];
  }

  onClearFont(fontField) {
    let selectedFontGuid = null;
    if (fontField === 'primary') selectedFontGuid = this.primaryFont;
    else selectedFontGuid = this.secondaryFont;
    const { isSystemFont } = this.menuFontList.find((font) => font.guid === selectedFontGuid);
    if (!isSystemFont) {
      this.fontBeingDeleted = fontField;
      this.fontDeletionModalVisible = true;
    }
  }

  onCreateFont(font) {
    if (this.fontBeingEdited === 'primary') {
      this.primaryFont = font.guid;
    } else {
      this.secondaryFont = font.guid;
    }
    this.fontModalVisible = false;
  }

  async onDeleteFont() {
    const fontGuid = this.fontBeingDeleted === 'primary' ? this.primaryFont : this.secondaryFont;
    await this.deleteFont(fontGuid);
    this.fontDeletionModalVisible = false;
    this.fontBeingDeleted = null;
  }

  async deleteFont(fontGuid) {
    try {
      await this.deleteMenuFontRequest(fontGuid);
      if (this.primaryFont === fontGuid) this.primaryFont = this.defaultFont.guid;
      if (this.secondaryFont === fontGuid) this.secondaryFont = this.defaultFont.guid;
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('errorDeletingFont')));
    } finally {
      this.addNotification(createSuccessNotification(this.$t('deletedFont')));
    }
  }

  onCancelFont() {
    this.fontModalVisible = false;
  }

  onCancelFontDeletion() {
    this.fontDeletionModalVisible = false;
  }

  onOpenFontCreateModal(selectedFont) {
    this.fontBeingEdited = selectedFont;
    this.fontModalVisible = true;
  }

  @Watch('theme')
  onUpdatedTheme(updatedTheme) {
    if (updatedTheme) {
      this.primaryColor = updatedTheme.primary_color;
      this.primaryFont = updatedTheme.primary_font;
      this.primaryFontSizeFactor = updatedTheme.primary_font_size_threshold;
      this.secondaryColor = updatedTheme.secondary_color;
      this.secondaryFont = updatedTheme.secondary_font;
      this.secondaryFontSizeFactor = updatedTheme.secondary_font_size_threshold;
      this.productSeparationFactor = updatedTheme.product_separation_threshold;
      this.descriptionSeparationFactor = updatedTheme.description_separation_threshold;
      this.accentColor = updatedTheme.accent_color;
      this.backgroundColor = updatedTheme.background_color;
      this.backgroundImage = updatedTheme.background_image;
      this.backgroundColorFreeText = updatedTheme.background_color_free_text;
      this.headerBackgroundColor = updatedTheme.header_background_color;
      this.backgroundImageFile = updatedTheme.background_image ? new File([], this.$t('previousFile')) : null;
      this.specialColor = updatedTheme.special_color;
      this.languageSelectTextColor = updatedTheme.languageTextColor;
      this.specialSpaceBorder = updatedTheme.special_space_border;
      this.shopBtnColor = updatedTheme.shopBtnColor;
      this.shopBtnTextColor = updatedTheme.shopBtnTextColor;
      this.borderColor = updatedTheme.border_color;
      this.borderWidth = updatedTheme.border_width;
      this.borderStyle = updatedTheme.border_style;
      this.subsectionBorderColor = updatedTheme.subsection_border_color;
      this.subsectionBorderWidth = updatedTheme.subsection_border_width;
      this.subsectionBorderStyle = updatedTheme.subsection_border_style;
      this.hasLogo = updatedTheme.has_logo;
      this.logoPosition = updatedTheme.logo_position;
      this.textOutlineColor = updatedTheme.text_outline_color;
      this.textOutlineWidth = updatedTheme.text_outline_width;
      this.popUpBackgroundColor = updatedTheme.pop_up_background_color;
      this.popUpTextColor = updatedTheme.pop_up_text_color;
      this.commercialDescriptionTextColor = updatedTheme.commercial_description_text_color;
      this.commercialDescriptionIndentation = updatedTheme.commercial_description_text_indentation;
      this.footerBackgroundColor = updatedTheme.footer_background_color;
      this.footerTextColor = updatedTheme.footer_text_color;
      this.footerTextSize = updatedTheme.footer_text_size;
      this.footerBrandingBackgroundColor = updatedTheme.footer_branding_background_color;
      this.footerBrandingTextColor = updatedTheme.footer_branding_text_color;
      this.footerBrandingTextSize = updatedTheme.footer_branding_text_size;
      this.sectionTitleBackgroundColor = updatedTheme.section_title_background_color;
      this.sectionTitleTextColor = updatedTheme.section_title_text_color;
      this.sectionTitlePosition = updatedTheme.section_title_position;
      this.bannerRecommendationBackgroundColor = updatedTheme.banner_recommendation_background_color;
      this.bannerRecommendationTextColor = updatedTheme.banner_recommendation_text_color;
      this.bannerArrowColor = updatedTheme.bannerArrowColor;
      this.productSeparatorBorderColor = updatedTheme.productSeparatorBorderColor;
      this.productSeparatorBorderStyle = updatedTheme.productSeparatorBorderStyle;
      this.productSeparatorBorderWidth = updatedTheme.productSeparatorBorderWidth;
    }
  }

  @Watch('visible')
  onUpdatedVisible(newVisible) {
    if (newVisible) this.getTheme();
  }

  @Watch('menuFontList')
  async onMenuFontListChanged(newFontList) {
    for (let i = 0; i < newFontList.length; i += 1) {
      const { fontFamily, url } = newFontList[i];
      // eslint-disable-next-line no-await-in-loop
      await loadFont(fontFamily, url);
    }
  }

  async getTheme() {
    try {
      this.theme = await this.themeRequest(this.themeGuid);
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('getThemeError'), null, 5000));
      this.$emit('cancel');
    }
  }

  get primaryStyle() {
    return {
      fontSize: `${12 + this.primaryFontSizeFactor}px`
    };
  }

  get secondaryStyle() {
    return {
      fontSize: `${13 + this.secondaryFontSizeFactor}px`
    };
  }

  get extraText() {
    return this.isAdvanced ? this.$t('defaultSettings') : this.$t('advancedSettings');
  }

  onCancel() {
    this.$emit('cancel');
  }

  onConfirm() {
    if (this.$refs.form.validate()) {
      this.theme.primary_color = this.primaryColor;
      this.theme.primary_font = this.primaryFont;
      this.theme.primary_font_size_threshold = this.primaryFontSizeFactor;
      this.theme.secondary_color = this.secondaryColor;
      this.theme.secondary_font = this.secondaryFont;
      this.theme.secondary_font_size_threshold = this.secondaryFontSizeFactor;
      this.theme.product_separation_threshold = this.productSeparationFactor;
      this.theme.description_separation_threshold = this.descriptionSeparationFactor;
      this.theme.accent_color = this.accentColor;
      this.theme.background_color = this.backgroundColor;
      this.theme.background_image = this.backgroundImageFile ? this.backgroundImageFile : null;
      this.theme.header_background_color = this.headerBackgroundColor;
      this.theme.special_color = this.specialColor;
      this.theme.languageTextColor = this.languageSelectTextColor;
      this.theme.special_space_border = this.specialSpaceBorder;
      this.theme.border_color = this.borderColor;
      this.theme.border_style = this.borderStyle;
      this.theme.border_width = this.borderWidth;
      this.theme.subsection_border_color = this.subsectionBorderColor;
      this.theme.subsection_border_style = this.subsectionBorderStyle;
      this.theme.subsection_border_width = this.subsectionBorderWidth;
      this.theme.has_logo = this.hasLogo;
      this.theme.logo_position = this.logoPosition;
      this.theme.text_outline_color = this.textOutlineColor;
      this.theme.text_outline_width = this.textOutlineWidth;
      this.theme.background_color_free_text = this.backgroundColorFreeText;
      this.theme.pop_up_background_color = this.popUpBackgroundColor;
      this.theme.pop_up_text_color = this.popUpTextColor;
      this.theme.commercial_description_text_color = this.commercialDescriptionTextColor;
      this.theme.commercial_description_text_indentation = this.commercialDescriptionIndentation;
      this.theme.footer_background_color = this.footerBackgroundColor;
      this.theme.footer_text_color = this.footerTextColor;
      this.theme.footer_text_size = this.footerTextSize;
      this.theme.footer_branding_background_color = this.footerBrandingBackgroundColor;
      this.theme.footer_branding_text_color = this.footerBrandingTextColor;
      this.theme.footer_branding_text_size = this.footerBrandingTextSize;
      this.theme.section_title_background_color = this.sectionTitleBackgroundColor;
      this.theme.section_title_text_color = this.sectionTitleTextColor;
      this.theme.section_title_position = this.sectionTitlePosition;
      this.theme.banner_recommendation_background_color = this.bannerRecommendationBackgroundColor;
      this.theme.banner_recommendation_text_color = this.bannerRecommendationTextColor;
      this.theme.bannerArrowColor = this.bannerArrowColor;
      this.theme.productSeparatorBorderStyle = this.productSeparatorBorderStyle;
      this.theme.productSeparatorBorderWidth = this.productSeparatorBorderWidth;
      this.theme.productSeparatorBorderColor = this.productSeparatorBorderColor;
      this.theme.shopBtnColor = this.shopBtnColor;
      this.theme.shopBtnTextColor = this.shopBtnTextColor;
      this.$emit('confirm', this.theme);
    }
  }

  switchAdvancedOptions() {
    this.isAdvanced = !this.isAdvanced;
  }
}
</script>

<style>
.v-color-picker__dot {
  box-shadow: 0 0 2px;
}
</style>

<style scoped>
.border-avatar {
  border: #000 1px;
}

.position-elements {
  left: 0;
  right: auto;
  font-size: 14px;
}

.style-format-padding {
  padding: 3px;
}

.style-format-margin {
  margin: 2px;
}

.my-tabs .v-tab {
  flex: 1;
  justify-content: center;
  margin-top: 5px;
}

</style>
